import { PaletteHelpers } from '@pratt/js/utils/palette-helpers';

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const TIME_ZONE = 'America/New_York';

export class HitHelpers {
  static getTypeDisplay(type) {
    switch (type) {
      case 'post':
        return 'News';
      case 'prattfolio-story':
        return 'Prattfolio Story';
      default:
        return type[0].toLocaleUpperCase() + type.slice(1);
    }
  }

  static Courses = {
    sectionsAsHtml(hit) {
      return `
        <ul class="course-hit__section-list">
          ${hit.sections.map(section => `
            <li class="course-hit__section-item">
              <span class="course-hit__section-days">${section.days.join(', ')}</span>
              <span class="course-hit__section-time">${section.start_time} – ${section.end_time}</span>
              <span class="course-hit__section-location">${section.location ? section.location.map(loc => loc.name).join(', ') : ''}</span>
            </li>
          `).join('')}
        </ul>
      `;
    },
  };

  static Events = {
    dateAsHTML(hit) {
      const start = new Date(
        new Date(hit.occurrences[0].start).toLocaleString('en-US', { timeZone: TIME_ZONE }),
      );
      return `
        <time class="event-hit__date" datetime="${start.toLocaleString()}">
          <span class="event-hit__date-month">${MONTHS[start.getMonth()]}</span>
          <span class="event-hit__date-day">${start.getDate()}</span>
        </time>
      `;
    },

    time(hit, opts = {}) {
      if (!hit.occurrences.length) {
        return '';
      }

      const start = new Date(
        new Date(hit.occurrences[0].start).toLocaleString('en-US', { timeZone: TIME_ZONE }),
      );
      const end = new Date(
        new Date(hit.occurrences[0].end).toLocaleString('en-US', { timeZone: TIME_ZONE }),
      );

      const timeFormat = new Intl.DateTimeFormat('en-US', { timeStyle: 'short' });
      const dateFormat = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
      const dateFormatNoYear = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric' });

      const isSameDay =
        start.getFullYear() === end.getFullYear() &&
        start.getMonth() === end.getMonth() &&
        start.getDate() === end.getDate();

      const isSameYear = start.getFullYear() === end.getFullYear();

      let time;
      if (hit.is_all_day) {
        if (isSameDay) {
          time = 'All Day';
          if (opts.includeDay) {
            time = dateFormat.format(start);
          }
        } else {
          if (isSameYear) {
            time = `<span>${dateFormatNoYear.format(start)} – ${dateFormat.format(
              end,
            )}</span> <span>All Day</span>`;
          } else {
            time = `<span>${dateFormat.format(start)} – ${dateFormat.format(
              end,
            )}</span> <span>All Day</span>`;
          }
        }
      } else {
        if (isSameDay) {
          time = `${timeFormat.format(start)} – ${timeFormat.format(end)}`;
          if (opts.includeDay) {
            time = `<span>${dateFormat.format(start)}</span> <span>${time}</span>`;
          }
        } else {
          let startDateDay = `${dateFormat.format(start)}`;
          if (isSameYear) {
            startDateDay = `${dateFormatNoYear.format(start)}`;
          }
          const endDateDay = `${dateFormat.format(end)}`;
          const startDateTime = `${timeFormat.format(start)}`;
          const endDateTime = `${timeFormat.format(end)}`;
          time = `<span>${startDateDay} – ${endDateDay}</span> <span>${startDateTime} – ${endDateTime}</span>`;
        }
      }

      return time;
    },

    location(hit) {
      if (hit.event_type === 'hybrid') {
        return `Online and ${hit.location}`;
      } else if (hit.event_type === 'physical') {
        return hit.location;
      } else {
        return 'Online Event';
      }
    },

    hitCallouts(hit) {
      if (!hit.primary_term) return '';
      return `<div class="event-hit__callout">${hit.primary_term}</div>`;
    },

    hitGradient(rank = 'tertiary', angle = null, bland = false) {
      return PaletteHelpers.getRandomGradient(rank, angle, bland);
    }
  };

  static DailyHub = {
    decodeHTMLEntities(encodedString) {
      const temp = document.createElement('textarea');
      temp.innerHTML = encodedString;
      const result = temp.value;
      temp.remove();
      return result;
    },

    hitMarkup(hit, blogID, isHighlighted = false) {
      const calloutOptions = {
        1: "<a href='/daily-hub'>the Daily Hub</a>",
        12: "<a href='/alumni/alumni-notes'>Alumni Notes</a>",
      }
      const url = hit.blogID !== 12 ? hit.url : hit.url.replace('/daily-hub/', '/alumni-notes/');
      const colorway = hit.colorway_special || hit.colorway_tertiary || hit.colorway_secondary || false;
      const { instagram_aspect_ratios } = window.pratt;
      const aspect_ratio = Object.prototype.hasOwnProperty.call(instagram_aspect_ratios, hit.aspect_ratio) ? instagram_aspect_ratios[hit.aspect_ratio] : '100%';
      const publishedDateObject = new Date(hit.published_timestamp * 1000);
      const dateOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      };
      return `
        <li class="daily-hub-hit${isHighlighted ? ' daily-hub__highlighted-item' : ''}">
          <article class="daily-hub-hit__article ${colorway ? `theme--${colorway}` : `theme--white`}">
            ${hit.blogID !== blogID ? `
              <p class="daily-hub-hit__article-callout">
                From ${calloutOptions[hit.blogID]}
              </p>
            ` : ``}
            <div class="daily-hub-hit__article-content">
              ${hit.instagram_post_id ? `
                <div style="padding-bottom: calc(${aspect_ratio} + 208px); position: relative;">
                  <div class="daily-hub-hit__instagram-skeleton" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0;"></div>
                  <iframe style="position: absolute;" width="100%" height="100%" src="https://www.instagram.com/p/${hit.instagram_post_id}/embed" frameborder="0" scrolling="yes" allowtransparency="true"></iframe>
                </div>
              ` : hit.thumbnail ? `
                <div class="daily-hub-hit__article-art">
                  <figure class="daily-hub-hit__article-figure">
                    <img
                      class="lazy-img lazyload daily-hub-hit__article-img"
                      data-src="${hit.thumbnail}"
                      data-sizes="auto"
                    />
                  </figure>
                </div>
              ` : ``}
              ${this.decodeHTMLEntities(hit.content)}
            </div>
            ${publishedDateObject ? `
              <p class="daily-hub-hit__article-date">
                <a href="${url}">
                  ${new Intl.DateTimeFormat('en-US', dateOptions).format(publishedDateObject)}
                </a>
              </p>
            ` : ``}
          </article>
        </li>
      `
    }
  };
}

export class OutletImageManager {
  constructor(rootEl) {
    this.rootEl = rootEl;
    this.outletLogos = JSON.parse(this.rootEl.dataset['outletLogos']);
    this._decoder = document.createElement('textarea');
  }

  decodeHtmlEntities(str) {
    this._decoder.innerHTML = str;
    return this._decoder.value;
  }

  getOutletImageHTML(outlets) {
    for(const outletName of outlets) {
      const decoded = this.decodeHtmlEntities(outletName);
      if (Object.prototype.hasOwnProperty.call(this.outletLogos, decoded)) {
        return this.outletLogos[decoded];
      }
    }

    return '';
  }
}
